// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Give heed to me and answer me;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I am restless in my complaining.<br> </p> </div></div>";
// Exports
module.exports = code;